import * as yup from "yup";

export const bookingFormSubmitSchema = yup.object({
  message: yup.string().when("$isMessageRequired", {
    is: true,
    then: (schema) => schema.required("Please write something"),
    otherwise: (schema) => schema.notRequired(),
  }),
  guest: yup.string().required("Guest is Required"),
  dates: yup.string().required("Please select dates range"),
});

export interface IBookingFormType {
  message?: string;
  guest: string;
  dates: string;
}

export type BookingFormValues = yup.InferType<typeof bookingFormSubmitSchema>;
